import CryptoJS from 'crypto-js';

const SECRET = process.env.REACT_APP_ENCRYPTION_KEY || "AIR_SECURE_READER_V1_2024";

export const decrypt = (ciphertext) => {
  if (!ciphertext || typeof ciphertext !== 'string') return ciphertext;
  // Prevent double decryption or decrypting non-encrypted text
  if (!ciphertext.startsWith('U2FsdGVkX1')) return ciphertext;
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText || ciphertext;
  } catch (e) {
    return ciphertext;
  }
};
